import { Injectable, Inject, InjectionToken } from '@angular/core';
import { environment } from '../../environments/environment';
import { translations } from './translations';

export const APP_LANGUAGE = new InjectionToken<'ja' | 'en'>('APP_LANGUAGE', {
  providedIn: 'root',
  factory: () => environment.language,
});

@Injectable({ providedIn: 'root' })
export class I18nService {
  constructor(@Inject(APP_LANGUAGE) private readonly lang: 'ja' | 'en') {}

  t(key: string, params?: Record<string, string | number>): string {
    const dict = translations[this.lang];
    let text = dict[key] ?? key;
    if (params) {
      for (const [k, v] of Object.entries(params)) {
        text = text.replace(`{${k}}`, String(v));
      }
    }
    return text;
  }
}
